module.exports = {"closeButtonText":"Fermer","thumbNailAlt":"Aperçu de l'image","next":"Page suivante","previous":"Page précédente","addNote":"Ajouter une note..."}


//////////////////
// WEBPACK FOOTER
// ./translations/fr-ca.json
// module id = 22
// module chunks = 0